import { accordionAnatomy as t } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as e, defineStyle as o } from "@chakra-ui/react";
const { defineMultiStyleConfig: r, definePartsStyle: n } = e(t.keys), a = o({
  borderTopWidth: "1px",
  borderColor: "gray.200",
  _last: {
    borderBottomWidth: "1px"
  }
}), l = o({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "subheading2",
  py: 2,
  px: 4,
  svg: {
    ml: 3,
    color: "teal.500"
  },
  _focusVisible: {
    boxShadow: "outline",
    position: "relative",
    zIndex: 1
  },
  _hover: {
    bg: "gray.100",
    svg: {
      color: "teal.600"
    }
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed"
  },
  _expanded: {
    svg: {
      color: "teal.700"
    },
    _hover: {
      bg: "gray.100"
    }
  }
}), i = o({
  bg: "teal.25",
  pt: 2,
  px: 4,
  pb: 4
}), s = n({
  root: {},
  container: a,
  button: l,
  panel: i
}), p = r({
  baseStyle: s
});
export {
  p as default
};
